
const SET_FORMAT = 'SET_FORMAT';
const GET_FORMAT = 'GET_FORMAT';
const SET_PROD_CAT_PROMOS = 'SET_PROD_CAT_PROMOS';
const SET_PROD_CAT_PRICES = 'SET_PROD_CAT_PRICES';
const SET_SUPPLIER_PROMOS = 'SET_SUPPLIER_PROMOS';
const SET_SUPPLIER_PRICES = 'SET_SUPPLIER_PRICES';


let initialState = {
    format: 'A4',
    productCategoryValues: {
        promos: '',
        prices: '',
    },
    supplierValues: {
        promos: '',
        prices: '',
    }
};

const dropdownsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORMAT: {
            return {
                ...state,
                format: action.format
            }
        }
        case GET_FORMAT: {
            return state.format
        }
        case SET_PROD_CAT_PROMOS: {
            return {
                ...state,
                productCategoryValues: {
                    ...state.productCategoryValues,
                    promos: action.payload
                }
            }
        }
        case SET_PROD_CAT_PRICES: {
            return {
                ...state,
                productCategoryValues: {
                    ...state.productCategoryValues,
                    prices: action.payload
                }
            }
        }
        case SET_SUPPLIER_PROMOS: {
            return {
                ...state,
                supplierValues: {
                    ...state.supplierValues,
                    promos: action.payload
                }
            }
        }
        case SET_SUPPLIER_PRICES: {
            return {
                ...state,
                supplierValues: {
                    ...state.supplierValues,
                    prices: action.payload
                }
            }
        }

        default:
            return state;
    }
};


export const setFormat = (format) => ({type: SET_FORMAT, format});
export const getFormat = (format) => ({type: GET_FORMAT, format});
const setProductCategoryPromosAction = (payload) => ({
    type: SET_PROD_CAT_PROMOS,
    payload
});
const setProductCategoryPricesAction = (payload) => ({
    type: SET_PROD_CAT_PRICES,
    payload
});

const setSupplierPromosAction = (payload) => ({
    type: SET_SUPPLIER_PROMOS,
    payload
});
const setSupplierPricesAction = (payload) => ({
    type: SET_SUPPLIER_PRICES,
    payload
});

export const setProductCategoryPromosDispatcher = (payload) => {
    return (dispatch) => {
        dispatch(setProductCategoryPromosAction(payload))
    }
};

export const setProductCategoryPricesDispatcher = (payload) => {
    return (dispatch) => {
        dispatch(setProductCategoryPricesAction(payload))
    }
};

export const setSupplierPromosDispatcher = (payload) => {
    return (dispatch) => {
        dispatch(setSupplierPromosAction(payload))
    }
};

export const setSupplierPricesDispatcher = (payload) => {
    return (dispatch) => {
        dispatch(setSupplierPricesAction(payload))
    }
};


export default dropdownsReducer;